import { getJSON, PASSPORT_HOST } from '../ultile';

import { checkAccountValidate, validateResetPwd } from '../validator';
import { encryption } from '../../utiles';
import languages from '../languages';

export const CHECK_ACCOUNT = 'checkAccount';
export const SEND_VRFCODE_EMAIL = 'sendVerifyCodeEmail';
export const VALIDATE_EMAIL_VRCODE = 'validateEmailCode';
export const RESET_PWD = 'resetPwd';
const SET_SECURITY_QUESSION = 'setSecurityQuession';
const CHECK_ACCOUNT_ACTION = PASSPORT_HOST + 'center/ForgetPwd';
const SEND_VERIFY_CODE_ACTION = PASSPORT_HOST + 'center/ForgetPwd/pwdSendMail';
const VALIDATE_EMAIL_VRCODE_ACTION =
  PASSPORT_HOST + 'center/ChangePwd/check_access';
const RESET_PWD_ACTION = PASSPORT_HOST + 'center/ChangePwd/reset';
const SET_BINDED_EMAIL = 'setBindedEmail';
const SET_ACCOUNT_TOKEN = 'setAccountToken';
export default {
  state: {
    securityQuessions: [],
    bindedEmail: false,
    accountToken: '',
  },
  mutations: {
    [SET_SECURITY_QUESSION](state, quessionList) {
      state.securityQuessions = [];
      for (let i = 0, len = quessionList.length; i < len; i++) {
        let quession = {
          id: quessionList[i].num,
          quession: quessionList[i].question,
          answer: '',
        };
        state.securityQuessions.push(quession);
      }
    },
    [SET_BINDED_EMAIL](state, idBind) {
      state.bindedEmail = idBind == 1;
    },
    [SET_ACCOUNT_TOKEN](state, token) {
      state.accountToken = token;
    },
  },
  actions: {
    [VALIDATE_EMAIL_VRCODE]({ commit, dispatch }, { userName, ckcode }) {
      return new Promise((resolve, reject) => {
        getJSON(VALIDATE_EMAIL_VRCODE_ACTION, {
          uname: userName,
          ckcode: ckcode,
          code: ckcode,
        }).then(({ errmsg, data }) => {
          if (errmsg) {
            // dispatch(SHOW_TIPS_MSG, {
            //   message: errmsg
            // })
            reject(new Error(errmsg));
            resolve(false);
          } else {
            resolve(data.token);
          }
        });
      });
    },
    [SEND_VRFCODE_EMAIL]({ commit, dispatch, state }, userName) {
      return new Promise((resolve, reject) => {
        getJSON(SEND_VERIFY_CODE_ACTION, {
          uname: userName,
          token: state.accountToken,
        }).then(({ errmsg, data }) => {
          if (errmsg) {
            // dispatch(SHOW_TIPS_MSG, {
            //   message: errmsg
            // })
            reject(new Error(errmsg));
          } else {
            resolve(data.EMAIL);
          }
        });
      });
    },
    [CHECK_ACCOUNT]({ commit, dispatch }, params) {
      var validateres = checkAccountValidate(params);
      return new Promise((resolve, reject) => {
        if (validateres.dirty) {
          // dispatch(SHOW_TIPS_MSG, {
          //   message: validateres.errmsg
          // })
          reject(new Error(validateres.errmsg));
        } else {
          getJSON(CHECK_ACCOUNT_ACTION, params).then(({ errmsg, data, res }) => {
            if (errmsg) {
              resolve({
                success: false,
                errmsg,
                type: 'apiError',
                res
              });
            } else if (
              data.is_bind_email != 1 &&
              data.check_question_list.length <= 0
            ) {
              resolve({
                success: false,
                errmsg: languages.get('findPwdByFixAccount'),
                type: 'findPwdByFixAccount',
                res
              });
            } else {
              commit(SET_SECURITY_QUESSION, data.check_question_list);
              commit(SET_BINDED_EMAIL, data.is_bind_email);
              commit(SET_ACCOUNT_TOKEN, data.token);
              resolve({
                success: true,
                errmsg,
              });
            }
          });
        }
      });
    },
    [RESET_PWD]({ commit, dispatch }, params) {
      var validateres = validateResetPwd(params);
      return new Promise((resolve, reject) => {
        if (validateres.dirty) {
          // dispatch(SHOW_TIPS_MSG, {
          //   message: validateres.errmsg
          // })
          reject(new Error(validateres.errmsg));
        } else {
          params.password = encryption(params.password);
          params.repassword = encryption(params.repassword);
          getJSON(RESET_PWD_ACTION, params).then(({ errmsg, data, res }) => {
            if (errmsg) {
              // dispatch(SHOW_TIPS_MSG, {
              //   message: errmsg
              // })
              reject(new Error(errmsg));
              resolve(false);
            } else {
              resolve(res?.msg);
            }
          });
        }
      });
    },
  },
};
